<template lang="pug">
div
  .px-6.py-4.d-flex.align-center
    v-btn.ml-n2(depressed icon @click="back")
      eva-icon.d-flex(name="arrow-ios-back" fill="#888")
    .flex-grow-1.text-center.text-lg.font-medium.mr-10 {{ $t('filter_total_contribution') }}
  v-divider
  .pa-6
    .mb-4 {{ $t('') }}:
    yc-select.mt-4(v-model="condition" :items="options")
    yc-text-field.mt-4(:label="$t('enter_value')" v-model="count" type="number")
    .yc-fixed-bottom-section
      .d-flex.align-center
        v-btn.button-Aa-medium(@click="back" color="neutral500" height=40 text) {{ $t('back') }}
        v-spacer
        v-btn.button-Aa-medium(@click="save" color="info500" height=40 dark depressed) {{ $t('save') }}
</template>

<script>
export default {
  props: ['filter'],
  data: () => ({
    count: null,
    condition: 'more',
    options: [
      { 
        id: 'more',
        label: 'More than'
      },
      { 
        id: 'less',
        label: 'Less than'
      },
      { 
        id: 'equal',
        label: 'Equal to'
      }
    ],
  }),
  created() {
    const { more, less, equal } = this.filter
    if (more) {
      this.condition = 'more'
      this.count = more
    }
    if (less) {
      this.condition = 'less'
      this.count = less
    }
    if (equal) {
      this.condition = 'equal'
      this.count = equal
    }
  },
  methods: {
    save() {
      const filter = this.getFilterData()
      this.$emit('update:filter', filter)
      this.back()
    },
    getFilterData() {
      switch (this.condition) {
        case 'more':
          return { 
            more: this.count * this.$currency.multiplier
          }
        case 'less':
          return { 
            less: this.count * this.$currency.multiplier
          }
        case 'equal':
          return {
            equal: this.count * this.$currency.multiplier
          }
        case 'between':
          return {
            between: this.count * this.$currency.multiplier
          }
        default:
          return {}
      }
    },
    back() {
      this.$emit('onBack')
    }
  }
}
</script>